/**
 * La lógica de las páginas públicas del registro de invitados, fuera del render para poder
 * probarla (ver docs/mapas/frontend.md → «La alerta de timbres»).
 */

export const TIPOS_LEGALES = [
  { tipo: 'aviso_privacidad', campo: 'acepta_aviso_privacidad', etiqueta: 'el Aviso de privacidad' },
  { tipo: 'terminos', campo: 'acepta_terminos', etiqueta: 'los Términos y condiciones' },
  { tipo: 'condiciones_uso', campo: 'acepta_condiciones_uso', etiqueta: 'las Condiciones de uso' },
]

/**
 * Finalidades secundarias del aviso de privacidad. **Opcionales**: no marcarlas no impide el
 * registro ni la prueba.
 */
export const FINALIDADES_SECUNDARIAS = [
  { campo: 'acepta_promociones', etiqueta: 'Recibir información comercial y promociones' },
  { campo: 'acepta_oferta_plan', etiqueta: 'Que me contacten para ofrecerme un plan al terminar la prueba' },
  { campo: 'acepta_encuestas', etiqueta: 'Responder encuestas de satisfacción' },
  { campo: 'acepta_novedades', etiqueta: 'Recibir novedades de productos y funcionalidades' },
]

/** El RFC se compara en mayúsculas: una prueba por RFC titular. */
export function normalizarRfc(valor) {
  return String(valor || '').trim().toUpperCase()
}

/** El usuario del invitado es su correo **en minúsculas**: así se guardó y así entra. */
export function normalizarCorreo(valor) {
  return String(valor || '').trim().toLowerCase()
}

/**
 * Lo que se manda a `POST /auth/registro/`.
 *
 * `documentos` lleva el `id` de cada documento **que se mostró**: si alguno cambió entre que se
 * abrió la página y se envió, el backend responde 409 y hay que volver a aceptarlo.
 */
export function datosRegistro(form, legales, campana) {
  const documentos = {}
  for (const d of legales || []) documentos[d.tipo] = d.id
  const datos = {
    campana,
    nombre: String(form.nombre || '').trim(),
    email: normalizarCorreo(form.email),
    telefono: String(form.telefono || '').trim(),
    despacho: String(form.despacho || '').trim(),
    rfc_titular: normalizarRfc(form.rfc_titular),
    estado: form.estado || '',
    ciudad: String(form.ciudad || '').trim(),
    password: form.password,
    documentos,
    sitio_web: form.sitio_web || '',
  }
  for (const { campo } of TIPOS_LEGALES) datos[campo] = !!form[campo]
  for (const { campo } of FINALIDADES_SECUNDARIAS) datos[campo] = !!form[campo]
  return datos
}

/** Los tres documentos aceptados. Sin ellos el botón no se habilita. */
export function aceptoTodo(form) {
  return TIPOS_LEGALES.every(({ campo }) => !!form[campo])
}

/**
 * El mensaje para el invitado a partir del error de axios. Primero el del backend, que ya viene
 * en español; los errores de campo se juntan en una línea.
 */
export function mensajeDeError(error) {
  const status = error?.response?.status
  const data = error?.response?.data
  if (status === 429) return 'Demasiados intentos. Espera unos minutos y vuelve a intentarlo.'
  if (data?.detail) return data.detail
  if (data?.error) return data.error
  if (data && typeof data === 'object') {
    const mensajes = Object.values(data).flat().filter((m) => typeof m === 'string')
    if (mensajes.length) return mensajes.join(' ')
  }
  if (!error?.response) return 'No hay conexión. Revisa tu internet y vuelve a intentarlo.'
  return 'Algo salió mal. Vuelve a intentarlo.'
}

/**
 * Las rutas que se ven sin sesión, fuera del layout. Una sola definición para `App.jsx` y para el
 * interceptor de 401 de `services/api.js`, que no debe mandar a `/login` a quien está aquí.
 */
export function esRutaPublica(pathname) {
  const p = String(pathname || '')
  return p === '/registro' || p.startsWith('/registro/') ||
    p === '/recuperar' || p.startsWith('/legal/')
}

/** Si el 409 fue porque los documentos legales cambiaron: hay que recargarlos y desmarcar. */
export function documentosCambiaron(error) {
  return error?.response?.data?.codigo === 'documentos_cambiaron'
}
